<template>
  <div :class="getClass()">
    <slot>
      {{ $t(defaultMessage)}}
    </slot>
  </div>
</template>

<script>
export default {
  props: {
    customClass: String
  },

  data () {
    return {
      // Required field
      defaultMessage: 'error.10'
    }
  },

  methods: {
    getClass () {
      return this.customClass ? this.customClass : 'error col-12 text-right'
    }
  }
}
</script>

<style scoped lang="scss">
  .error {
    margin-bottom: -0.5rem;
    font-size: 0.8rem;
    color: red;

    * {
      color: red;
    }
  }
</style>
